/* eslint-disable no-unused-vars */
import { Grid, Typography } from "@mui/material";
import PConfirm from "../../../components/pos/PConfirm";
import PDialog from "../../../components/pos/PDialog";
import PSelect from "../../../components/pos/PSelect";
import PCheck from "../../../components/pos/PCheck";
import PText from "../../../components/pos/PText";
import PDatePicker from "../../../components/pos/PDatePicker";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../../utils/API";
import db from "../../../db/db";
import { PrintUtils } from "../../../utils/PrintUtils";
import { SyncUtils } from "../../../utils/SyncUtils";

import axios from "axios";
import { SaleUtils } from "../../../utils/SaleUtils";
import { StringUtils } from "../../../utils/StringUtils";

export default function ChequePrint(props) {
  const { t } = useTranslation();
  const translate = t;
  const [origObject, setOrigObject] = useState(null);
  const [mode, setMode] = useState("create");
  const [openWindow, setOpenWindow] = useState(false);
  const [windowTitle, setWindowTitile] = useState("Cheque Print");
  const [confirmContext, setConfirmContext] = useState({ open: false });
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [id, setId] = useState("");
  const [chequeNumber, setChequeNumber] = useState("");
  const [chequeNumberError, setChequeNumberError] = useState("");
  const [bank, setBank] = useState({});
  const [bankNameError, setBankNameError] = useState("");
  const [templateName, setTemplateName] = useState({});
  const [templateNameError, setTemplateNameError] = useState("");
  const [amount, setAmount] = useState(0);
  const [amountError, setAmountError] = useState("");
  const [amountWords, setAmountWords] = useState("");
  const [chequeDate, setChequeDate] = useState("");
  const [chequeDateError, setChequeDateError] = useState("");
  const [payTo, setPayTo] = useState("");
  const [payToError, setPayToError] = useState("");
  const [reference, setReference] = useState("");
  const [referenceError, setReferenceError] = useState("");
  const [code, setCode] = useState("");

  const [liveValidation, setLiveValidation] = useState(false);
  const [bankOptions, setBankOptions] = useState([]);
  const [templateOptions, setTemplateOptions] = useState([]);
  const [printingModeOptions, setPrintingModeOptions] = useState([
    { value: "LOCAL", name: "Local" },
    { value: "CLOUD_PRINT", name: "Cloud Print Service" },
  ]);

  const [printingMode, setPrintingMode] = useState("");
  const [printingModeError, setPrintingModeError] = useState("");
  const [printer, setPrinter] = useState("");
  const [printerError, setPrinterError] = useState("");
  const [printerOptions, setPrinterOptions] = useState([]);
  const [eventSource, setEventSource] = useState();

  /*CODEGEN_STATE_INIT ######## DO_NOT_REMOVE ###########*/

  props.biRef.chequeRef = {
    showChequePrintWindow: showChequePrintWindow,
  };
  useEffect(() => {
    if (liveValidation && chequeNumber === "")
      setChequeNumberError(translate("Cheque Number is Required"));
    else setChequeNumberError("");
  }, [chequeNumber]);
  useEffect(() => {
    if (
      liveValidation &&
      (bank.name === "" || bank.name == undefined || bank.name == null)
    )
      setBankNameError(translate("Bank name is Required"));
    else setBankNameError("");
  }, [bank]);
  useEffect(() => {
    if (
      liveValidation &&
      bank.name &&
      (templateName === "" || templateName == undefined || templateName == null)
    )
      setTemplateNameError(translate("Template name is Required"));
    else setTemplateNameError("");
  }, [templateName]);
  useEffect(() => {
    if (liveValidation && amount === "")
      setAmountError(translate("Amount is Required"));
    else setAmountError("");
  }, [amount]);
  useEffect(() => {
    if (liveValidation && payTo === "")
      setPayToError(translate("Pay to is Required"));
    else setPayToError("");
  }, [payTo]);
  useEffect(() => {
    if (liveValidation && chequeDate === "")
      setChequeDateError(translate("Cheque Date is Required"));
    else setChequeDateError("");
  }, [chequeDate]);
  useEffect(() => {
    if (liveValidation && printer === "")
      setPrinterError(translate("Printer Required"));
    else setPrinterError("");
  }, [printer]);
  useEffect(() => {
    if (liveValidation && printingMode === "")
      setPrintingModeError(translate("Printing Mode Required"));
    else setPrintingModeError("");
  }, [printingMode]);

  useEffect(() => {
    if (printingMode && printingMode.value === "CLOUD_PRINT") {
      refreshCloudPrinters();
    }
    if (printingMode && printingMode.value === "LOCAL") {
      refreshLocalPrinters();
    }
  }, [printingMode]);
  useEffect(() => {
    populateTemplateOptions(bank);
  }, [bank]);

  useEffect(() => {}, []);

  /*CODEGEN_INIT_USE_EFFECT ######## DO_NOT_REMOVE ###########*/

  function showChequePrintWindow(data, eventSource) {
    let lastPrinter = localStorage.getItem("chequePrinter");
    let lastprintingMode = localStorage.getItem("chequePrintingMode");
    setPrinter(lastPrinter ? JSON.parse(lastPrinter) : "");
    setPrintingMode(lastprintingMode ? JSON.parse(lastprintingMode) : "");
    setEventSource(eventSource);
    resetFields(data);
    if (eventSource == "vendor") {
      setPayTo(data.toLedgerName);
    } else {
      setPayTo(data.payeeName);
    }
    setReference(data.voucherNumber);
    setAmount(data.amount);

    setMode("create");
    setLiveValidation(false);
    setOpenWindow(true);
    populateBankOptions(bank);
    console.log(data);
  }

  async function refreshCloudPrinters() {
    try {
      console.log("#### refreshCloudPrinters");
      props.showProgress(translate("Checking Cloud Printers..."));
      let otherPrinters = [];

      let comports = [];

      let [url, token] = await PrintUtils.getCloudPrintToken();
      const config = {
        headers: { Authorization: `Bearer ${token}` },
      };
      let devices = await axios.get(
        "/cloudprintbackend/api/v1/core/devices",
        config
      );

      console.log(devices);
      for (let device of devices.data) {
        console.log(device);
        if (device.deviceFamily === "PRINTER") {
          otherPrinters.push({
            value: device.id,
            name: device.name,
          });
          // if (localStorage.getItem("w_barcodePrinter")) {
          //   setBarcodePrinter(
          //     JSON.parse(localStorage.getItem("w_barcodePrinter"))
          //   );
          // }
          // if (localStorage.getItem("w_shelfLabelPrinter")) {
          //   setShelfLabelPrinter(
          //     JSON.parse(localStorage.getItem("w_barcodePrinter"))
          //   );
          // }
        }
      }
      setPrinterOptions(otherPrinters);

      props.hideProgress();
    } catch (err) {
      console.log(err);
      props.hideProgress();
    }
  }
  async function refreshLocalPrinters() {
    try {
      console.log("#### refreshCloudPrinters");
      props.showProgress(translate("Checking Local Printers..."));
      let otherPrinters = [];

      let devices = await axios.get(
        "http://localhost:3337/agent/device/printers"
      );

      for (let device of devices.data) {
        console.log(device);
        otherPrinters.push({
          value: device.id,
          name: device.name,
        });
        // if (localStorage.getItem("checkPrinter")) {
        //   setBarcodePrinter(
        //     JSON.parse(localStorage.getItem("w_barcodePrinter"))
        //   );
        // }
        // if (localStorage.getItem("w_shelfLabelPrinter")) {
        //   setShelfLabelPrinter(
        //     JSON.parse(localStorage.getItem("w_shelfLabelPrinter"))
        //   );
        // }
      }
      setPrinterOptions(otherPrinters);

      props.hideProgress();
    } catch (err) {
      console.log(err);
      props.hideProgress();
    }
  }

  async function populateBankOptions(bankName) {
    let bankOptions = [];
    let { data } = await API.get("/api/v1/get/transaction/bank/ledgers");
    data.forEach((element) => {
      bankOptions.push({ code: element.code, name: element.name });
    });
    setBankOptions(bankOptions);
  }
  async function populateTemplateOptions(bank) {
    let templateOptions = [];
    if (bank.code) {
      console.log("populateTemplateOptions");
      let checkPrintConfig = await db.config
        .where("name")
        .equals("CHECK_PRINT_TEMPLATES")
        .toArray();
      let configJson = JSON.parse(checkPrintConfig[0].configTxt);
      configJson.forEach((config) => {
        if (config.code === bank.code) {
          config.templates.forEach((template) => {
            templateOptions.push({
              id: template,
              name: template,
            });
          });
        }
      });
    }
    if (templateOptions.length == 1) {
      setTemplateName(templateOptions[0]);
    }
    setTemplateOptions(templateOptions);
  }
  async function populateChequeDetails(id) {
    {
      try {
        let { data } = await API.get("/api/v1/print/cheque" + id);
        setOrigObject(data);
        populateData(data);
        setOpenWindow(true);
      } catch (err) {
        console.error(err);
        props.showMessage(
          "error",
          translate("Not able to retrive Vendor data from server")
        );
      }
    }
  }

  function populateData(bean) {
    setId(bean.id);
    setPrinter(SaleUtils.getOption2(printerOptions, bean.printer));
    setPrintingMode({ name: bean.printingMode, value: bean.printingMode });
    setChequeNumber(bean.chequeNumber);
    setBank({ name: bean.bankName, code: bean.bankCode });
    setTemplateName(bean.templateName);
    setAmount(bean.amount);
    setAmountWords(bean.amountWords);
    setChequeDate(bean.chequeDate);
    setPayTo(bean.payTo);
    setReference(bean.reference);
    setEventSource(bean.paymentTargetType);
    /*CODEGEN_POPULATE_DATA ######## DO_NOT_REMOVE ###########*/
  }

  function resetFields(data) {
    setId("");
    setPrinter(null);
    setPrinterError("");
    setPrintingModeError("");
    setTemplateName("");
    setTemplateNameError("");
    setAmount("");
    setAmountError("");
    setAmountWords("");
    setChequeDate("");
    setChequeDateError("");
    setPayTo("");
    setPayToError("");
    setReference("");
    setReferenceError("");
    setCode("AUTO");
    setBank({});
    setBankNameError("");
    setChequeNumber("");
    setChequeNumberError("");
    /*CODEGEN_RESET_FIELDS ######## DO_NOT_REMOVE ###########*/
  }

  function onCloseWindow() {
    setOpenWindow(false);
  }

  async function onYesNoClicked(context, value) {
    setConfirmOpen(false);
    if (value == "yes") {
      setOpenWindow(false);
    }
  }

  async function onSave() {
    if (validate()) {
      var payload = createPayload();
      try {
        if (mode === "create") {
          let result = await API.post("/api/v1/print/cheque", payload);
          props.showMessage("success", translate("Saved Successfully"));
          populateData(result.data);
          setMode("view");
          PrintUtils.printReceipt(
            {
              receiptPrinter: result.data.printer,
              printingMode: result.data.printingMode,
            },
            { template: result.data.templateName, config: "" },
            result.data,
            props.setAlert,
            true,
            translate,
            false,
            false,
            null,
            props.pdfViewer
          );
        }
      } catch (err) {
        props.showMessage("error", translate("Not able to print cheque"));
      }
    }
  }

  function createPayload() {
    let saveObject = Object.create(null);
    saveObject["id"] = id;
    saveObject["printer"] = printer.value;
    saveObject["printingMode"] = printingMode.value;
    saveObject["chequeNumber"] = chequeNumber;
    saveObject["bankName"] = bank.name;
    saveObject["bankCode"] = bank.code;
    saveObject["templateName"] = templateName.name;
    saveObject["amount"] = amount;
    saveObject["chequeDate"] = StringUtils.getIsoDate(chequeDate);
    saveObject["code"] = code;
    saveObject["payTo"] = payTo;
    saveObject["reference"] = reference;
    saveObject["paymentTargetType"] = eventSource;

    console.log(mode);
    return saveObject;
  }

  function validate() {
    let flag = true;
    if (!bank.name) {
      setBankNameError(translate("Bank is Required"));
      flag = false;
    }
    if (!chequeNumber || chequeNumber === "") {
      setChequeNumberError(translate("Cheque Number is Required"));
      flag = false;
    }
    if ((bank.name != null || bank.name != "") && !templateName) {
      setTemplateNameError(translate("Template is Required"));
      flag = false;
    }
    if (!payTo || payTo === "") {
      setPayToError(translate("Pay to required"));
      flag = false;
    }
    if (!chequeDate) {
      setChequeDateError(translate("Cheque Date required"));
      flag = false;
    }
    if (!amount || amount === "") {
      setAmountError(translate("Amount required"));
      flag = false;
    }
    if (!printer) {
      setPrinterError("Printer Required");
      flag = false;
    }
    if (!printingMode) {
      setPrintingModeError("Printing Mode Required");
      flag = false;
    }
    if (!flag) {
      setLiveValidation(true);
    }
    /*CODEGEN_VALIDATE ######## DO_NOT_REMOVE ###########*/
    return flag;
  }

  const content = (
    <div>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12}>
          <table width="100%">
            <tbody>
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Printing Mode")}
                  </Typography>
                </td>
                <td>
                  <PSelect
                    options={printingModeOptions}
                    value={printingMode}
                    errorMessage={printingModeError}
                    onChange={(event, newValue) => {
                      setPrintingMode(newValue);
                      localStorage.setItem(
                        "chequePrintingMode",
                        JSON.stringify(newValue)
                      );
                    }}
                  ></PSelect>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Printer")}
                  </Typography>
                </td>
                <td>
                  <PSelect
                    options={printerOptions}
                    value={printer}
                    errorMessage={printerError}
                    onChange={(event, newValue) => {
                      setPrinter(newValue);
                      localStorage.setItem(
                        "chequePrinter",
                        JSON.stringify(newValue)
                      );
                    }}
                  ></PSelect>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">{translate("Code")}</Typography>
                </td>
                <td>
                  <PText
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                  ></PText>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Cheque Number")}
                  </Typography>
                </td>
                <td>
                  <PText
                    value={chequeNumber}
                    error={chequeNumberError}
                    onChange={(e) => setChequeNumber(e.target.value)}
                  ></PText>
                </td>
              </tr>

              <tr>
                <td>
                  <Typography variant="body1">{translate("Bank")}</Typography>
                </td>
                <td>
                  <PSelect
                    options={bankOptions}
                    value={bank ? bank.name : ""}
                    errorMessage={bankNameError}
                    onChange={(event, newValue) => {
                      console.log(newValue);
                      populateTemplateOptions(newValue);
                      setBank(newValue);
                    }}
                  ></PSelect>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Template")}
                  </Typography>
                </td>
                <td>
                  <PSelect
                    options={templateOptions}
                    value={templateName}
                    disabled={
                      bank.name == null ||
                      bank.name === "" ||
                      bank.name == undefined
                        ? true
                        : false
                    }
                    errorMessage={templateNameError}
                    onChange={(event, newValue) => {
                      setTemplateName(newValue);
                    }}
                  ></PSelect>
                </td>
              </tr>

              <tr>
                <td>
                  <Typography variant="body1">{translate("Amount")}</Typography>
                </td>
                <td>
                  <PText
                    value={amount}
                    error={amountError}
                    onChange={(e) => setAmount(e.target.value)}
                  ></PText>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Cheque Date")}
                  </Typography>
                </td>
                <td>
                  <PDatePicker
                    value={chequeDate}
                    type="date"
                    error={chequeDateError}
                    onChange={(e) => setChequeDate(e)}
                  ></PDatePicker>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">{translate("Pay To")}</Typography>
                </td>
                <td>
                  <PText
                    value={payTo}
                    onChange={(e) => setPayTo(e.target.value)}
                    error={payToError}
                  ></PText>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Reference")}
                  </Typography>
                </td>
                <td>
                  <PText
                    value={reference}
                    error={referenceError}
                    onChange={(e) => setReference(e.target.value)}
                  ></PText>
                </td>
              </tr>
              {/*CODEGEN_REACT_COMPONENT ######## DO_NOT_REMOVE ###########*/}
            </tbody>
          </table>
        </Grid>
      </Grid>
    </div>
  );

  function isDataChanged() {
    if (mode === "create") {
      if (bank.name || bank.name != "") return true;
    }

    /*CODEGEN_DATA_CHANGE_DETECTION ######## DO_NOT_REMOVE ###########*/

    return false;
  }
  return (
    <div>
      {openWindow && (
        <PDialog
          content={content}
          title={windowTitle}
          maxWidth={"sm"}
          fullWidth={true}
          open={true}
          showChequePrint={true}
          onCloseWindow={onCloseWindow}
          hideSave={true}
          onChequePrint={onSave}
          mode={mode}
          isDataChanged={isDataChanged}
        ></PDialog>
      )}

      {confirmOpen && (
        <PConfirm
          open={confirmOpen}
          context={confirmContext}
          onButtonClicked={onYesNoClicked}
        ></PConfirm>
      )}
    </div>
  );
}
